import React from "react";
import './SelectBtn.css';

const SelectBtn = (props) => {
  const { text, url, from, round } = props;
  return (
    <div className="btn-wrapper" onClick={props.onClick}>
      <div className="btn-thumbnail-wrapper"><img className="btn-thumbnail" src={url} alt="" /></div>
      <div className={`btn-text complete btn-text-${from} btn-text-round${round}`}><b>{text}</b></div>
    </div>
  );
}
export default SelectBtn;